const LOCALE_LABELS = {
  es: 'Spanish',
  en: 'English',
  fr: 'French',
  de: 'German',
  pt: 'Portuguese',
}

export default function TranslationBanner({ show, locale }) {
  if (!show) return null

  const label = LOCALE_LABELS[locale] || locale

  return (
    <div className="mb-4 flex items-center justify-between px-3 py-2 rounded border bg-amber-950/40 border-amber-800/50">
      <span className="text-xs font-mono text-amber-400">
        This page is not yet available in {label}. Showing English version.
      </span>
      <a
        href="https://github.com/zaramando/anamnesis"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs font-mono text-amber-500 hover:text-amber-300 shrink-0 ml-4"
      >
        Contribute a translation →
      </a>
    </div>
  )
}
